/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerNoteAuthor } from './';
import {
    FreelancerNoteAuthorFromJSON,
    FreelancerNoteAuthorFromJSONTyped,
    FreelancerNoteAuthorToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerNoteResource
 */
export interface FreelancerNoteResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerNoteResource
     */
    id: string;
    /**
     * The actual note
     * 
     * @type {string}
     * @memberof FreelancerNoteResource
     */
    content: string;
    /**
     * The time the comment was created.
     * 
     * @type {Date}
     * @memberof FreelancerNoteResource
     */
    createdOn: Date;
    /**
     * Indicates the last time the comment was edited, if null it means
     * the note was never edited.
     * 
     * @type {Date}
     * @memberof FreelancerNoteResource
     */
    editedOn?: Date;
    /**
     * 
     * @type {FreelancerNoteAuthor}
     * @memberof FreelancerNoteResource
     */
    author: FreelancerNoteAuthor;
}

/**
 * Check if a given object implements the FreelancerNoteResource interface.
 */
export function instanceOfFreelancerNoteResource(value: object): value is FreelancerNoteResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdOn' in value) || value['createdOn'] === undefined) return false;
    if (!('author' in value) || value['author'] === undefined) return false;
    return true;
}

export function FreelancerNoteResourceFromJSON(json: any): FreelancerNoteResource {
    return FreelancerNoteResourceFromJSONTyped(json, false);
}

export function FreelancerNoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerNoteResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
        'createdOn': (new Date(json['createdOn'])),
        'editedOn': json['editedOn'] == null ? undefined : (new Date(json['editedOn'])),
        'author': FreelancerNoteAuthorFromJSON(json['author']),
    };
}

export function FreelancerNoteResourceToJSON(value?: FreelancerNoteResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'content': value['content'],
        'createdOn': ((value['createdOn']).toISOString()),
        'editedOn': value['editedOn'] == null ? undefined : ((value['editedOn']).toISOString()),
        'author': FreelancerNoteAuthorToJSON(value['author']),
    };
}

